import { render, staticRenderFns } from "./StudyEffectiveness.vue?vue&type=template&id=16098580&scoped=true"
import script from "./StudyEffectiveness.vue?vue&type=script&lang=js"
export * from "./StudyEffectiveness.vue?vue&type=script&lang=js"
import style0 from "./StudyEffectiveness.vue?vue&type=style&index=0&id=16098580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16098580",
  null
  
)

export default component.exports